import script from "./Campaign.vue?vue&type=script&setup=true&lang=js"
export * from "./Campaign.vue?vue&type=script&setup=true&lang=js"

import "./Campaign.vue?vue&type=style&index=0&id=1e739d72&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e739d72"]])

export default __exports__